import React, { useEffect, useState } from "react";
import { useBannerContent, useSlide } from "./hooks";
import { MemberBenefitsLink } from "./MemberBenefitsLink/MemberBenefitsLink";
import {
  containerVariants,
  slide,
  slideContent
} from "./StickyFooterMemberMobile.css";
import { usePathname } from "next/navigation";

type Props = {
  isExperimentalPdp: boolean;
};

const PAGE_INCLUSIONS = /^\/(us)?\/?$/;

export const StickyFooterMemberMobile: React.FC<Props> = ({
  isExperimentalPdp
}) => {
  const [showSavingBanner, setShowSavingsBanner] = useState(false);
  const { bannerContent: textSlides, showMemberBenefitsLink } =
    useBannerContent();
  const { setMouseDown } = useSlide(textSlides.length + 1);
  const pathName = usePathname();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPosition = window.scrollY;
      const totalPageHeight = document.documentElement.scrollHeight;
      const visibleViewportHeight = document.documentElement.clientHeight;

      const shouldBeVisibleOnScroll =
        currentScrollPosition + visibleViewportHeight < totalPageHeight - 100;
      setShowSavingsBanner(shouldBeVisibleOnScroll);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (!showSavingBanner && pathName.match(PAGE_INCLUSIONS)) {
    return null;
  }

  return (
    <div
      id="member-sticky-footer"
      className={
        isExperimentalPdp ? containerVariants.thin : containerVariants.default
      }
      onTouchStart={() => {
        setMouseDown(true);
      }}
      onTouchEnd={() => {
        setMouseDown(false);
      }}
      onTouchCancel={() => {
        setMouseDown(false);
      }}
    >
      {textSlides.map((text, index) => {
        const key = `${text.substring(0, 3)}-${index}`;
        return (
          <div key={key} id={`sticky-footer-item-${index}`} className={slide}>
            <p
              className={slideContent}
              dangerouslySetInnerHTML={{
                __html: text
              }}
            />
          </div>
        );
      })}
      {showMemberBenefitsLink && (
        <div id={`sticky-footer-item-${textSlides.length}`} className={slide}>
          <p className={slideContent}>
            <MemberBenefitsLink />
          </p>
        </div>
      )}
    </div>
  );
};
